import React, { useCallback, useContext, useEffect, useState } from "react";
import { Table } from "antd";
import axios from "axios";
import { UserInfo } from "../../../../context";

const Adjustment = () => {
  const [adjustmentList, setAdjustmentList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);

  const columns = [
    {
      title: "Business Name",
      //   dataIndex: "business_name",
      render: (text, record) => (
        <p>{text.adjustmentmerchantinfo.business_name}</p>
      ),
    },
    {
      title: "Description",
      render: (text, record) => <p>{text.description}</p>,
    },
    {
      title: "Reason",
      render: (text, record) => <p>{text.reason}</p>,
    },
  ];

  const tableProps = {
    bordered: false,
    // loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getAdjustmentList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/admin/adjustment-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setAdjustmentList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getAdjustmentList();
  }, [getAdjustmentList]);

  return (
    <div style={{ overflowX: "auto" }}>
      <Table
        {...tableProps}
        pagination={{
          position: ["bottomCenter"],
        }}
        columns={tableColumns}
        dataSource={adjustmentList.data.length > 0 ? adjustmentList.data : []}
        scroll={scroll}
        rowKey={(record) => record.id}
      />
    </div>
  );
};

export default Adjustment;
